import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: string; output: string };
  JSON: { input: any; output: any };
  JSONObject: { input: Record<string, any>; output: Record<string, any> };
  Upload: { input: File; output: File };
};

/** Accept invite response with redirect */
export type AcceptInviteMutationResponse = {
  redirect?: Maybe<RedirectType>;
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Billing account */
export type Account = {
  admin_rights?: Maybe<Scalars["Boolean"]["output"]>;
  assessments?: Maybe<Scalars["Boolean"]["output"]>;
  config?: Maybe<Scalars["JSONObject"]["output"]>;
  dimensions?: Maybe<Array<Maybe<Scalars["JSONObject"]["output"]>>>;
  id?: Maybe<Scalars["Int"]["output"]>;
  is_owner?: Maybe<Scalars["Boolean"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  positions?: Maybe<Scalars["Boolean"]["output"]>;
  projects?: Maybe<Scalars["Boolean"]["output"]>;
  /** This is field is deprecated and always returns null */
  subscription?: Maybe<AccountSubscriptionDetails>;
  teams?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Contact details for the user who gets billed */
export type AccountBillingUser = {
  avatar_url?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  first_name?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  initials?: Maybe<Scalars["String"]["output"]>;
  last_name?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type AccountSubscriptionDetails = {
  allowedProfiles?: Maybe<Scalars["Int"]["output"]>;
  billingUser?: Maybe<AccountBillingUser>;
  isOwner?: Maybe<Scalars["String"]["output"]>;
  seatsUsed?: Maybe<Scalars["Int"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
};

/** Survey */
export type ActiveSurvey = {
  blocks_count?: Maybe<Scalars["Int"]["output"]>;
  complete?: Maybe<Scalars["Boolean"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  duration?: Maybe<Scalars["String"]["output"]>;
  hasIntro?: Maybe<Scalars["Boolean"]["output"]>;
  icon?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  intro?: Maybe<Scalars["JSONObject"]["output"]>;
  main_text?: Maybe<Scalars["String"]["output"]>;
  rows_count?: Maybe<Scalars["Int"]["output"]>;
  survey_rows?: Maybe<Array<Maybe<SurveyRowLoaded>>>;
  text_tid?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
  ui_template?: Maybe<Scalars["String"]["output"]>;
};

export type AddPersonInput = {
  account_access_level?: InputMaybe<WorkspaceAccessLevel>;
  account_role?: InputMaybe<WorkspaceRoles>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  first_name?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  last_name?: InputMaybe<Scalars["String"]["input"]>;
  linkedin?: InputMaybe<Scalars["String"]["input"]>;
  linkedin_data?: InputMaybe<Scalars["JSON"]["input"]>;
  organization?: InputMaybe<OrganizationRelationInput>;
  project?: InputMaybe<ProjectRelationObjectInput>;
  send_invite?: InputMaybe<InviteInput>;
  team?: InputMaybe<TeamRelationObjectInput>;
};

export type Assessment = {
  created_at?: Maybe<Scalars["Date"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  person?: Maybe<Person>;
  project_id?: Maybe<Scalars["Int"]["output"]>;
  scorecard?: Maybe<Scorecard>;
  summary?: Maybe<Scalars["String"]["output"]>;
};

export type AssessmentEvaluation = {
  assessment_id?: Maybe<Scalars["Int"]["output"]>;
  created_at?: Maybe<Scalars["Date"]["output"]>;
  created_by?: Maybe<Scalars["Int"]["output"]>;
  evaluation?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  meta?: Maybe<Scalars["JSONObject"]["output"]>;
  person_id?: Maybe<Scalars["Int"]["output"]>;
  row_id?: Maybe<Scalars["Int"]["output"]>;
};

export type AssessmentNote = {
  assessment_id?: Maybe<Scalars["Int"]["output"]>;
  created_at?: Maybe<Scalars["Date"]["output"]>;
  created_by?: Maybe<Person>;
  id?: Maybe<Scalars["Int"]["output"]>;
  note?: Maybe<Scalars["String"]["output"]>;
  person_id?: Maybe<Scalars["Int"]["output"]>;
  row_id?: Maybe<Scalars["Int"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
};

export type AssessmentOrder = {
  assessment_link?: Maybe<Scalars["String"]["output"]>;
  assessment_type?: Maybe<Scalars["String"]["output"]>;
  completed_at?: Maybe<Scalars["String"]["output"]>;
  created_at?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  redirect_url?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  survey?: Maybe<Survey>;
  updated_at?: Maybe<Scalars["String"]["output"]>;
};

export type AssessmentRowDimensionInput = {
  dim_id?: InputMaybe<Scalars["Int"]["input"]>;
  target_max?: InputMaybe<Scalars["Int"]["input"]>;
  target_min?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AssessmentSurvey = {
  assessment_type?: Maybe<Scalars["String"]["output"]>;
  group?: Maybe<Scalars["String"]["output"]>;
};

export type AssessmentSurveyAnswerInput = {
  answer: Scalars["Int"]["input"];
  duration_ms?: InputMaybe<Scalars["Int"]["input"]>;
  question_dim_id: Scalars["Int"]["input"];
};

export type AssessmentSurveyRow = {
  answer?: Maybe<Scalars["Int"]["output"]>;
  block_id?: Maybe<Scalars["Int"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  question_dim_id?: Maybe<Scalars["Int"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type Attachment = {
  content_type?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  file_name?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  isEmbedded?: Maybe<Scalars["Boolean"]["output"]>;
  tags?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type AttachmentsFilter = {
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  position_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A dimension text */
export type DimText = {
  /** low, mid, high */
  bucket?: Maybe<Scalars["String"]["output"]>;
  dim_id?: Maybe<Scalars["Int"]["output"]>;
  /** The priority of the text in the bucket. Default is 1. */
  display_order?: Maybe<Scalars["Int"]["output"]>;
  text?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Deprecated in favor of bucket. Will be removed in future releases. */
  value?: Maybe<Scalars["Int"]["output"]>;
};

/** A dimension */
export type Dimension = {
  code?: Maybe<Scalars["String"]["output"]>;
  dim_id?: Maybe<Scalars["Int"]["output"]>;
  group?: Maybe<Scalars["String"]["output"]>;
  group_title?: Maybe<Scalars["String"]["output"]>;
  parent?: Maybe<Scalars["String"]["output"]>;
  parent_id?: Maybe<Scalars["Int"]["output"]>;
  parent_title?: Maybe<Scalars["String"]["output"]>;
  scores?: Maybe<Array<Maybe<Score>>>;
  type?: Maybe<Scalars["String"]["output"]>;
};

/** The dimension object */
export type DimensionLoaded = {
  answer?: Maybe<SurveyAnswerObject>;
  behaviours?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  description_neg?: Maybe<Scalars["String"]["output"]>;
  description_pos?: Maybe<Scalars["String"]["output"]>;
  description_short?: Maybe<Scalars["String"]["output"]>;
  description_tid?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  name_neg?: Maybe<Scalars["String"]["output"]>;
  name_pos?: Maybe<Scalars["String"]["output"]>;
  question_left?: Maybe<Scalars["String"]["output"]>;
  question_opposite_tid?: Maybe<Scalars["String"]["output"]>;
  question_right?: Maybe<Scalars["String"]["output"]>;
  question_tid?: Maybe<Scalars["String"]["output"]>;
};

export type DimensionsFilter = {
  group?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  people?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  personal?: InputMaybe<Scalars["Boolean"]["input"]>;
  position_id?: InputMaybe<Scalars["Int"]["input"]>;
  team_id?: InputMaybe<Scalars["Int"]["input"]>;
  type?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type InviteInput = {
  org_id: Scalars["Int"]["input"];
  project_id?: InputMaybe<Scalars["Int"]["input"]>;
  team_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Mutation response with message and mutated object ids. */
export type MutationResponse = {
  /** The list on ids of the mutated objects. This is available for CRUD mutations for bulk and single operations. For agregated utility mutations this will be empty. */
  ids?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  message?: Maybe<Scalars["String"]["output"]>;
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

/** A note */
export type Note = {
  assessment_id?: Maybe<Scalars["Int"]["output"]>;
  created_by?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  person_id?: Maybe<Scalars["Int"]["output"]>;
  row_id?: Maybe<Scalars["Int"]["output"]>;
  text?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
};

export type NotesFilter = {
  assessment_id?: InputMaybe<Scalars["Int"]["input"]>;
  position_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Notification type */
export type Notification = {
  id?: Maybe<Scalars["Int"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
  url?: Maybe<Scalars["String"]["output"]>;
};

export type OrganizationAccessLevel = "EDIT" | "FULL" | "LIMITED" | "NONE";

export type OrganizationRelationInput = {
  access_level?: InputMaybe<OrganizationAccessLevel>;
  id: Scalars["Int"]["input"];
  role?: InputMaybe<OrganizationRoles>;
};

export type OrganizationRoles = "ADMIN" | "CANDIDATE" | "MEMBER";

export type OrganizationType = {
  admin_rights?: Maybe<Scalars["Boolean"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  people?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  projects?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  teams?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
};

export type PeopleFilter = {
  org_id?: InputMaybe<Scalars["Int"]["input"]>;
  project_id?: InputMaybe<Scalars["Int"]["input"]>;
  team_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Administration capabilities for the authorized person on a specific resource (invite/change role/access/revoke). */
export type PermissionAdministration = {
  can_change_access_level?: Maybe<Scalars["Boolean"]["output"]>;
  can_change_role?: Maybe<Scalars["Boolean"]["output"]>;
  can_invite?: Maybe<Scalars["Boolean"]["output"]>;
  can_revoke?: Maybe<Scalars["Boolean"]["output"]>;
  constraints?: Maybe<PermissionAdministrationConstraints>;
  grantable_access_levels?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  grantable_roles?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** Unique identifier for client-side caching. */
  id?: Maybe<Scalars["String"]["output"]>;
  max_grant_access_level?: Maybe<Scalars["String"]["output"]>;
  max_grant_role?: Maybe<Scalars["String"]["output"]>;
};

/** Structured constraints the client can use for safe permission admin UX. */
export type PermissionAdministrationConstraints = {
  notes?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  organization_full_implies_admin?: Maybe<Scalars["Boolean"]["output"]>;
  workspace_admin_edit_no_manage_people?: Maybe<Scalars["Boolean"]["output"]>;
};

/** A person */
export type Person = {
  assessment_orders?: Maybe<Array<Maybe<AssessmentOrder>>>;
  avatar?: Maybe<Scalars["String"]["output"]>;
  completed_dim_types?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  email?: Maybe<Scalars["String"]["output"]>;
  first_name?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  initials?: Maybe<Scalars["String"]["output"]>;
  invite?: Maybe<PersonInvite>;
  is_contact?: Maybe<Scalars["Boolean"]["output"]>;
  is_guest?: Maybe<Scalars["Boolean"]["output"]>;
  last_name?: Maybe<Scalars["String"]["output"]>;
  linkedin?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  phone?: Maybe<Scalars["String"]["output"]>;
  roles?: Maybe<Array<Maybe<PersonRole>>>;
  /** @deprecated This field is deprecated. Use notes instead */
  summary?: Maybe<Summary>;
  survey_completion?: Maybe<Array<Maybe<SurveyCompletion>>>;
};

/** An invite */
export type PersonInvite = {
  created_at?: Maybe<Scalars["String"]["output"]>;
  secret?: Maybe<Scalars["String"]["output"]>;
};

/** A person note */
export type PersonNoteType = {
  created_at?: Maybe<Scalars["Date"]["output"]>;
  created_by?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  note?: Maybe<Scalars["String"]["output"]>;
  person_id?: Maybe<Scalars["Int"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
};

export type PersonNotesFilter = {
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
};

/** A list object of roles for a person */
export type PersonRole = {
  /** The access control of the person. */
  access_level?: Maybe<Scalars["String"]["output"]>;
  /** The actions the person has for the role. */
  actions?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** People administration capabilities for the authorized user on this resource (invite/change role/access/revoke). */
  administration?: Maybe<PermissionAdministration>;
  /** The context identifier for the role. */
  id?: Maybe<Scalars["String"]["output"]>;
  /** The context object identifier. */
  obj_id?: Maybe<Scalars["Int"]["output"]>;
  /** This field is needed to have a unique identifier for the role for Apollo Client caching. */
  person_id?: Maybe<Scalars["Int"]["output"]>;
  /** The role of the person. */
  role?: Maybe<Scalars["String"]["output"]>;
  /** The context type of role. */
  type?: Maybe<Scalars["String"]["output"]>;
};

/** Position kanban step */
export type PositionKanbanStep = {
  action?: Maybe<Scalars["String"]["output"]>;
  actionTitle?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  people?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  title?: Maybe<Scalars["String"]["output"]>;
};

/** A project */
export type Project = {
  candidates?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  client_name?: Maybe<Scalars["String"]["output"]>;
  config?: Maybe<Scalars["JSON"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  is_demo?: Maybe<Scalars["Boolean"]["output"]>;
  kanban_columns?: Maybe<Array<Maybe<PositionKanbanStep>>>;
  meta?: Maybe<Scalars["JSON"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  objectives?: Maybe<Scalars["String"]["output"]>;
  org_id?: Maybe<Scalars["Int"]["output"]>;
  scorecard_id?: Maybe<Scalars["Int"]["output"]>;
  team_id?: Maybe<Scalars["Int"]["output"]>;
};

export type ProjectAccessLevel = "FULL" | "NONE" | "READ";

export type ProjectAssessmentRowInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  dimensions?: InputMaybe<Array<InputMaybe<AssessmentRowDimensionInput>>>;
  group_title?: InputMaybe<Scalars["String"]["input"]>;
  icon?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  order?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
};

/** A note */
export type ProjectNote = {
  created_at?: Maybe<Scalars["String"]["output"]>;
  created_by?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  person_id?: Maybe<Scalars["Int"]["output"]>;
  project_id?: Maybe<Scalars["Int"]["output"]>;
  text?: Maybe<Scalars["String"]["output"]>;
  /** Default is 'note'. */
  type?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["String"]["output"]>;
};

export type ProjectRelationObjectInput = {
  access_level?: InputMaybe<ProjectAccessLevel>;
  id: Scalars["Int"]["input"];
  role?: InputMaybe<ProjectRoles>;
};

export type ProjectRoles = "CANDIDATE" | "COLLABORATOR";

export type ProjectsFilter = {
  org_id: Scalars["Int"]["input"];
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  team_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Redirect information */
export type RedirectType = {
  account_id?: Maybe<Scalars["Int"]["output"]>;
  url?: Maybe<Scalars["String"]["output"]>;
};

export type ResourceType = "ACCOUNT" | "ORGANIZATION" | "PROJECT" | "TEAM";

/** Root level for all database mutations */
export type RootMutation = {
  acceptInvite?: Maybe<AcceptInviteMutationResponse>;
  addPeople?: Maybe<MutationResponse>;
  archiveOrganization?: Maybe<MutationResponse>;
  assessmentLinkOrder?: Maybe<Scalars["String"]["output"]>;
  cloneProjectScorecardToWorkspace?: Maybe<MutationResponse>;
  completeOnboarding?: Maybe<Scalars["Boolean"]["output"]>;
  completeOnboardingStep?: Maybe<MutationResponse>;
  createAccount?: Maybe<MutationResponse>;
  createAssessment?: Maybe<Assessment>;
  createOrganization?: Maybe<OrganizationType>;
  createProject?: Maybe<Project>;
  createTask?: Maybe<MutationResponse>;
  createTeam?: Maybe<Team>;
  deleteAssessment?: Maybe<Assessment>;
  deleteCandidateAttachment?: Maybe<Scalars["Int"]["output"]>;
  deleteOrg?: Maybe<MutationResponse>;
  deletePersonNote?: Maybe<Scalars["Boolean"]["output"]>;
  deleteProject?: Maybe<Project>;
  deleteProjectAssessmentRow?: Maybe<MutationResponse>;
  deleteProjectAssessmentRows?: Maybe<MutationResponse>;
  deleteProjectNote?: Maybe<MutationResponse>;
  deleteScorecard?: Maybe<MutationResponse>;
  deleteScorecardRows?: Maybe<MutationResponse>;
  deleteTeam?: Maybe<MutationResponse>;
  deleteTeamNote?: Maybe<Scalars["Boolean"]["output"]>;
  deleteUserNote?: Maybe<Scalars["Boolean"]["output"]>;
  discardSurveyAnswers?: Maybe<MutationResponse>;
  evaluatePerson?: Maybe<AssessmentEvaluation>;
  finishAssessmentOrder?: Maybe<MutationResponse>;
  finishSurveyMutation?: Maybe<ActiveSurvey>;
  modifyTeam?: Maybe<Team>;
  removeAvatar?: Maybe<Viewer>;
  removePersonFromOrganization?: Maybe<MutationResponse>;
  removePersonFromPosition?: Maybe<MutationResponse>;
  removePersonFromTeam?: Maybe<MutationResponse>;
  removePersonFromWorkspace?: Maybe<MutationResponse>;
  reorderPositionKanban?: Maybe<MutationResponse>;
  resendInvite?: Maybe<MutationResponse>;
  saveSurveyAnswer?: Maybe<MutationResponse>;
  saveSurveyAnswers?: Maybe<MutationResponse>;
  sendContactInvite?: Maybe<MutationResponse>;
  sendProfileReminder?: Maybe<Scalars["Boolean"]["output"]>;
  setNewAccountOnboardingUsecase?: Maybe<Scalars["Boolean"]["output"]>;
  startFileEmbedding?: Maybe<Scalars["Boolean"]["output"]>;
  toggleGettingStarted?: Maybe<Viewer>;
  toggleShowPositionTour?: Maybe<Viewer>;
  toggleShowTeamTour?: Maybe<Viewer>;
  updateAccount?: Maybe<Account>;
  updateOrg?: Maybe<OrganizationType>;
  updatePassword?: Maybe<Viewer>;
  updateProject?: Maybe<MutationResponse>;
  updateUser?: Maybe<Viewer>;
  uploadAttachment?: Maybe<MutationResponse>;
  uploadAvatarMutation?: Maybe<Viewer>;
  upsertAssessmentNote?: Maybe<AssessmentNote>;
  upsertAssessmentSummary?: Maybe<MutationResponse>;
  upsertNote?: Maybe<Note>;
  /** This endpoint currently only supports updating existing person essential information. Person is not upserted when not found. */
  upsertPerson?: Maybe<MutationResponse>;
  /** This endpoint upserts an existing person role in the context of the organization, account or team. */
  upsertPersonAccessLevel?: Maybe<MutationResponse>;
  upsertPersonNote?: Maybe<PersonNoteType>;
  /** This endpoint upserts an existing person role in the context of the organization, account or team. */
  upsertPersonRole?: Maybe<MutationResponse>;
  upsertPersonScore?: Maybe<Dimension>;
  upsertPersonScoresBulk?: Maybe<MutationResponse>;
  upsertProjectAssessmentRows?: Maybe<MutationResponse>;
  upsertProjectNote?: Maybe<ProjectNote>;
  upsertScorecard?: Maybe<Scorecard>;
  upsertScorecardRows?: Maybe<MutationResponse>;
  upsertTeamNote?: Maybe<TeamNoteType>;
  upsertUserNote?: Maybe<UserNoteType>;
  /**
   *
   *     Validates multiple emails against people in the resource.
   *     For each email, if person exists, returns person object with roles list, otherwise returns an empty person record.
   *
   *     Response can be used to invite new people to the account or account resources (e.g., positions, teams, etc.) and/or
   *     validate the persons availability to add to resources.
   *
   */
  validatePeopleByEmail?: Maybe<ValidatePeopleResponse>;
  /**
   *
   *     Validates an email against people in the account.
   *     If person exists, returns person object with roles list, otherwise returns an empty person record.
   *
   *     Response can be used to invite new people to the account or account resources (e.g., positions, teams, etc.) and/or
   *     validate the persons availability to add to resources.
   *
   * @deprecated Use validatePeopleByEmail instead. This endpoint will be removed in the future.
   */
  validatePersonByEmail?: Maybe<ValidatePersonResponse>;
};

/** Root level for all database mutations */
export type RootMutationAcceptInviteArgs = {
  id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationAddPeopleArgs = {
  people?: InputMaybe<Array<InputMaybe<AddPersonInput>>>;
};

/** Root level for all database mutations */
export type RootMutationArchiveOrganizationArgs = {
  org_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationAssessmentLinkOrderArgs = {
  assessmentType: Scalars["String"]["input"];
  redirectUrl: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationCloneProjectScorecardToWorkspaceArgs = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  projectId: Scalars["Int"]["input"];
  title?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationCompleteOnboardingStepArgs = {
  step: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationCreateAccountArgs = {
  name: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationCreateAssessmentArgs = {
  person_id: Scalars["Int"]["input"];
  project_id: Scalars["Int"]["input"];
  scorecard_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationCreateOrganizationArgs = {
  account_id: Scalars["Int"]["input"];
  name: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationCreateProjectArgs = {
  client_name?: InputMaybe<Scalars["String"]["input"]>;
  config?: InputMaybe<Scalars["JSONObject"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  objectives?: InputMaybe<Scalars["String"]["input"]>;
  org_id: Scalars["Int"]["input"];
  scorecard_id?: InputMaybe<Scalars["Int"]["input"]>;
  team_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationCreateTaskArgs = {
  authorizedKeys?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  params?: InputMaybe<Scalars["JSONObject"]["input"]>;
  type: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationCreateTeamArgs = {
  config?: InputMaybe<Scalars["JSONObject"]["input"]>;
  name: Scalars["String"]["input"];
  org_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationDeleteAssessmentArgs = {
  assessment_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationDeleteCandidateAttachmentArgs = {
  id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationDeleteOrgArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationDeletePersonNoteArgs = {
  id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationDeleteProjectArgs = {
  id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationDeleteProjectAssessmentRowArgs = {
  id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationDeleteProjectAssessmentRowsArgs = {
  project_id: Scalars["Int"]["input"];
  rowIds: Array<InputMaybe<Scalars["Int"]["input"]>>;
};

/** Root level for all database mutations */
export type RootMutationDeleteProjectNoteArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationDeleteScorecardArgs = {
  id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationDeleteScorecardRowsArgs = {
  row_ids?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  scorecard_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationDeleteTeamArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationDeleteTeamNoteArgs = {
  id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationDeleteUserNoteArgs = {
  id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationDiscardSurveyAnswersArgs = {
  assessment_order_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationEvaluatePersonArgs = {
  assessment_id?: InputMaybe<Scalars["Int"]["input"]>;
  evaluation?: InputMaybe<Scalars["Int"]["input"]>;
  meta?: InputMaybe<Scalars["JSONObject"]["input"]>;
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  row_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationFinishAssessmentOrderArgs = {
  assessment_order_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationFinishSurveyMutationArgs = {
  answers?: InputMaybe<Array<InputMaybe<SurveyAnswerInputType>>>;
  survey_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationModifyTeamArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
  name: Scalars["String"]["input"];
  org_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationRemovePersonFromOrganizationArgs = {
  org_id?: InputMaybe<Scalars["Int"]["input"]>;
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationRemovePersonFromPositionArgs = {
  keep_access?: InputMaybe<Scalars["Boolean"]["input"]>;
  person_id: Scalars["Int"]["input"];
  position_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationRemovePersonFromTeamArgs = {
  person_id: Scalars["Int"]["input"];
  team_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationRemovePersonFromWorkspaceArgs = {
  person_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationReorderPositionKanbanArgs = {
  column_id: Scalars["Int"]["input"];
  order: Scalars["Int"]["input"];
  person_id: Scalars["Int"]["input"];
  position_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationResendInviteArgs = {
  person_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationSaveSurveyAnswerArgs = {
  answer: Scalars["Int"]["input"];
  assessment_order_id: Scalars["Int"]["input"];
  duration_ms?: InputMaybe<Scalars["Int"]["input"]>;
  question_dim_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationSaveSurveyAnswersArgs = {
  answers: Array<AssessmentSurveyAnswerInput>;
  assessment_order_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationSendContactInviteArgs = {
  person_id: Scalars["Int"]["input"];
  project_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationSendProfileReminderArgs = {
  person_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationSetNewAccountOnboardingUsecaseArgs = {
  usecase: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationStartFileEmbeddingArgs = {
  file_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationUpdateAccountArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationUpdateOrgArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationUpdatePasswordArgs = {
  new_password: Scalars["String"]["input"];
  old_password: Scalars["String"]["input"];
  repeat_new_password: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationUpdateProjectArgs = {
  client_name?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  objectives?: InputMaybe<Scalars["String"]["input"]>;
  scorecard_id?: InputMaybe<Scalars["Int"]["input"]>;
  team_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationUpdateUserArgs = {
  companySize?: InputMaybe<Scalars["String"]["input"]>;
  first_name?: InputMaybe<Scalars["String"]["input"]>;
  last_name?: InputMaybe<Scalars["String"]["input"]>;
  linkedIn?: InputMaybe<Scalars["String"]["input"]>;
  occupation?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationUploadAttachmentArgs = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  file?: InputMaybe<Scalars["Upload"]["input"]>;
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  project_id: Scalars["Int"]["input"];
  size: Scalars["Int"]["input"];
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** Root level for all database mutations */
export type RootMutationUploadAvatarMutationArgs = {
  image?: InputMaybe<Scalars["Upload"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationUpsertAssessmentNoteArgs = {
  assessment_id: Scalars["Int"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  row_id?: InputMaybe<Scalars["Int"]["input"]>;
  text: Scalars["String"]["input"];
  type: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationUpsertAssessmentSummaryArgs = {
  assessment_id: Scalars["Int"]["input"];
  summary?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationUpsertNoteArgs = {
  assessment_id?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  position_id?: InputMaybe<Scalars["Int"]["input"]>;
  row_id?: InputMaybe<Scalars["Int"]["input"]>;
  team_id?: InputMaybe<Scalars["Int"]["input"]>;
  text?: InputMaybe<Scalars["String"]["input"]>;
  type: Scalars["String"]["input"];
  user_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationUpsertPersonArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  first_name?: InputMaybe<Scalars["String"]["input"]>;
  last_name?: InputMaybe<Scalars["String"]["input"]>;
  linkedin?: InputMaybe<Scalars["String"]["input"]>;
  person_id: Scalars["Int"]["input"];
  phone?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationUpsertPersonAccessLevelArgs = {
  access_level: Scalars["String"]["input"];
  id: Scalars["Int"]["input"];
  person_id: Scalars["Int"]["input"];
  type: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationUpsertPersonNoteArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
  note: Scalars["String"]["input"];
  person_id: Scalars["Int"]["input"];
  type: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationUpsertPersonRoleArgs = {
  id: Scalars["Int"]["input"];
  person_id: Scalars["Int"]["input"];
  role: Scalars["String"]["input"];
  type: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationUpsertPersonScoreArgs = {
  dim_id: Scalars["Int"]["input"];
  person_id: Scalars["Int"]["input"];
  score: Scalars["Float"]["input"];
};

/** Root level for all database mutations */
export type RootMutationUpsertPersonScoresBulkArgs = {
  person_id: Scalars["Int"]["input"];
  scores: Array<InputMaybe<ScoreInput>>;
};

/** Root level for all database mutations */
export type RootMutationUpsertProjectAssessmentRowsArgs = {
  project_id: Scalars["Int"]["input"];
  rows?: InputMaybe<Array<InputMaybe<ProjectAssessmentRowInput>>>;
};

/** Root level for all database mutations */
export type RootMutationUpsertProjectNoteArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  project_id?: InputMaybe<Scalars["Int"]["input"]>;
  text?: InputMaybe<Scalars["String"]["input"]>;
  type: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationUpsertScorecardArgs = {
  category_id?: InputMaybe<Scalars["Int"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  project_id?: InputMaybe<Scalars["Int"]["input"]>;
  tag_id?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationUpsertScorecardRowsArgs = {
  rows?: InputMaybe<Array<InputMaybe<ProjectAssessmentRowInput>>>;
  scorecard_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationUpsertTeamNoteArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
  note: Scalars["String"]["input"];
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  team_id: Scalars["Int"]["input"];
  type: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationUpsertUserNoteArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
  note: Scalars["String"]["input"];
  type: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationValidatePeopleByEmailArgs = {
  emails?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  resource?: InputMaybe<ResourceType>;
  resourceId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationValidatePersonByEmailArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root query */
export type RootQuery = {
  account?: Maybe<Account>;
  accounts?: Maybe<Array<Maybe<Account>>>;
  assessment?: Maybe<Assessment>;
  assessmentOrder?: Maybe<AssessmentOrder>;
  assessmentOrderCompletion?: Maybe<AssessmentOrder>;
  assessments?: Maybe<Array<Maybe<Assessment>>>;
  attachmentReadSignedUrl?: Maybe<Scalars["String"]["output"]>;
  attachments?: Maybe<Array<Maybe<Attachment>>>;
  authorizedPerson?: Maybe<Person>;
  dictionary?: Maybe<Array<Maybe<DimText>>>;
  dimensions?: Maybe<Array<Maybe<Dimension>>>;
  evaluations?: Maybe<Array<Maybe<AssessmentEvaluation>>>;
  notes?: Maybe<Array<Maybe<Note>>>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
  organization?: Maybe<OrganizationType>;
  organizations?: Maybe<Array<Maybe<OrganizationType>>>;
  people?: Maybe<Array<Maybe<Person>>>;
  person?: Maybe<Person>;
  personNotes?: Maybe<Array<Maybe<PersonNoteType>>>;
  project?: Maybe<Project>;
  projectNotes?: Maybe<Array<Maybe<ProjectNote>>>;
  projects?: Maybe<Array<Maybe<Project>>>;
  scorecard?: Maybe<Scorecard>;
  scorecardTagsAndCategories?: Maybe<ScorecardTagAndCategory>;
  scorecards?: Maybe<Array<Maybe<Scorecard>>>;
  shareCandidateProfile?: Maybe<Scalars["String"]["output"]>;
  survey?: Maybe<ActiveSurvey>;
  surveys?: Maybe<Array<Maybe<AssessmentSurvey>>>;
  team?: Maybe<Team>;
  teamNotes?: Maybe<Array<Maybe<TeamNoteType>>>;
  teams?: Maybe<Array<Maybe<Team>>>;
  userNotes?: Maybe<Array<Maybe<UserNoteType>>>;
  viewer?: Maybe<Viewer>;
  wisgptContextToken?: Maybe<Scalars["String"]["output"]>;
};

/** Root query */
export type RootQueryAccountArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryAssessmentArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryAssessmentOrderArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryAssessmentOrderCompletionArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryAssessmentsArgs = {
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  project_id?: InputMaybe<Scalars["Int"]["input"]>;
  scorecard_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root query */
export type RootQueryAttachmentReadSignedUrlArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryAttachmentsArgs = {
  filter?: InputMaybe<AttachmentsFilter>;
};

/** Root query */
export type RootQueryDimensionsArgs = {
  filter?: InputMaybe<DimensionsFilter>;
};

/** Root query */
export type RootQueryEvaluationsArgs = {
  assessment_id?: InputMaybe<Scalars["Int"]["input"]>;
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  project_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root query */
export type RootQueryNotesArgs = {
  filter?: InputMaybe<NotesFilter>;
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root query */
export type RootQueryOrganizationArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryOrganizationsArgs = {
  account_id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryPeopleArgs = {
  filter?: InputMaybe<PeopleFilter>;
};

/** Root query */
export type RootQueryPersonArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryPersonNotesArgs = {
  filter?: InputMaybe<PersonNotesFilter>;
};

/** Root query */
export type RootQueryProjectArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryProjectNotesArgs = {
  person_id: Scalars["Int"]["input"];
  project_id: Scalars["Int"]["input"];
  type?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root query */
export type RootQueryProjectsArgs = {
  filter: ProjectsFilter;
};

/** Root query */
export type RootQueryScorecardArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryScorecardsArgs = {
  scorecard_ids?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

/** Root query */
export type RootQueryShareCandidateProfileArgs = {
  org_id: Scalars["Int"]["input"];
  person_id: Scalars["Int"]["input"];
  project_id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQuerySurveyArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryTeamArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryTeamNotesArgs = {
  filter?: InputMaybe<TeamNotesFilter>;
};

/** Root query */
export type RootQueryTeamsArgs = {
  filter: TeamsFilter;
};

/** Root query */
export type RootQueryUserNotesArgs = {
  filter?: InputMaybe<UserNotesFilter>;
};

/** Root query */
export type RootQueryWisgptContextTokenArgs = {
  assessment_id?: InputMaybe<Scalars["Int"]["input"]>;
  org_id?: InputMaybe<Scalars["Int"]["input"]>;
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  position_id?: InputMaybe<Scalars["Int"]["input"]>;
  project_id?: InputMaybe<Scalars["Int"]["input"]>;
  scorecard_id?: InputMaybe<Scalars["Int"]["input"]>;
  survey_config?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  team_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A score */
export type Score = {
  key?: Maybe<Scalars["String"]["output"]>;
  obj_id?: Maybe<Scalars["Int"]["output"]>;
  obj_type?: Maybe<Scalars["String"]["output"]>;
  value?: Maybe<Scalars["Float"]["output"]>;
};

export type ScoreInput = {
  dim_id: Scalars["Int"]["input"];
  score: Scalars["Float"]["input"];
};

/** Assessment scorecard */
export type Scorecard = {
  category?: Maybe<ScorecardCategory>;
  created_at?: Maybe<Scalars["Date"]["output"]>;
  created_by?: Maybe<Scalars["Int"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  is_global?: Maybe<Scalars["Boolean"]["output"]>;
  meta?: Maybe<Scalars["JSONObject"]["output"]>;
  objectives?: Maybe<Scalars["String"]["output"]>;
  project_id?: Maybe<Scalars["Int"]["output"]>;
  rows?: Maybe<Array<Maybe<ScorecardRow>>>;
  tag?: Maybe<ScorecardTag>;
  title?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
};

/** Scorecard category */
export type ScorecardCategory = {
  color?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type ScorecardRow = {
  color?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  dimensions?: Maybe<Array<Maybe<ScorecardRowDimension>>>;
  example_prompts?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  group_title?: Maybe<Scalars["String"]["output"]>;
  icon?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  meta?: Maybe<Scalars["JSONObject"]["output"]>;
  order?: Maybe<Scalars["Int"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
};

export type ScorecardRowDimension = {
  dim_id?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  target_max?: Maybe<Scalars["Int"]["output"]>;
  target_min?: Maybe<Scalars["Int"]["output"]>;
};

/** Tag for scorecard */
export type ScorecardTag = {
  id?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type ScorecardTagAndCategory = {
  categories?: Maybe<Array<Maybe<ScorecardCategory>>>;
  tags?: Maybe<Array<Maybe<ScorecardTag>>>;
};

/** A profile summary */
export type Summary = {
  text?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
};

export type Survey = {
  assessment_type?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  intro?: Maybe<Scalars["JSONObject"]["output"]>;
  rows?: Maybe<Array<Maybe<AssessmentSurveyRow>>>;
  ui?: Maybe<Scalars["String"]["output"]>;
};

export type SurveyAnswerInputType = {
  answer?: InputMaybe<Scalars["Int"]["input"]>;
  duration_ms?: InputMaybe<Scalars["Int"]["input"]>;
  obj_id?: InputMaybe<Scalars["Int"]["input"]>;
  obj_type_id?: InputMaybe<Scalars["Int"]["input"]>;
  question_dim_id?: InputMaybe<Scalars["Int"]["input"]>;
  subject_id?: InputMaybe<Scalars["Int"]["input"]>;
  subject_type_id?: InputMaybe<Scalars["Int"]["input"]>;
  survey_row_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Survey answer object */
export type SurveyAnswerObject = {
  answer?: Maybe<Scalars["Int"]["output"]>;
  duration_ms?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  obj_type_id?: Maybe<Scalars["Int"]["output"]>;
  question_dim_id?: Maybe<Scalars["Int"]["output"]>;
  subject_id?: Maybe<Scalars["Int"]["output"]>;
  subject_type_id?: Maybe<Scalars["Int"]["output"]>;
  survey_row_id?: Maybe<Scalars["Int"]["output"]>;
};

/** A survey completion */
export type SurveyCompletion = {
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  survey_id?: Maybe<Scalars["Int"]["output"]>;
  survey_type?: Maybe<Scalars["String"]["output"]>;
  text_id?: Maybe<Scalars["String"]["output"]>;
};

/** The survey row with dimension */
export type SurveyRowLoaded = {
  dimension?: Maybe<DimensionLoaded>;
  external_trait_id?: Maybe<Scalars["Int"]["output"]>;
  question_dim_id?: Maybe<Scalars["Int"]["output"]>;
  row_block_id?: Maybe<Scalars["Int"]["output"]>;
  row_id?: Maybe<Scalars["Int"]["output"]>;
  survey_id?: Maybe<Scalars["Int"]["output"]>;
  survey_row_id?: Maybe<Scalars["Int"]["output"]>;
};

/** A Team */
export type Team = {
  admin_rights?: Maybe<Scalars["Boolean"]["output"]>;
  config?: Maybe<Scalars["JSON"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  is_demo?: Maybe<Scalars["Boolean"]["output"]>;
  members?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  name?: Maybe<Scalars["String"]["output"]>;
  org_id?: Maybe<Scalars["Int"]["output"]>;
};

export type TeamAccessLevel = "FULL" | "NONE" | "READ";

/** A team note */
export type TeamNoteType = {
  created_at?: Maybe<Scalars["Date"]["output"]>;
  created_by?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  note?: Maybe<Scalars["String"]["output"]>;
  person_id?: Maybe<Scalars["Int"]["output"]>;
  team_id?: Maybe<Scalars["Int"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
};

export type TeamNotesFilter = {
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  team_id?: InputMaybe<Scalars["Int"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export type TeamRelationObjectInput = {
  access_level?: InputMaybe<TeamAccessLevel>;
  id: Scalars["Int"]["input"];
  role?: InputMaybe<TeamRoles>;
};

export type TeamRoles = "COLLABORATOR" | "MEMBER";

export type TeamsFilter = {
  org_id: Scalars["Int"]["input"];
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A user note */
export type UserNoteType = {
  created_at?: Maybe<Scalars["Date"]["output"]>;
  created_by?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  note?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  user_id?: Maybe<Scalars["Int"]["output"]>;
};

export type UserNotesFilter = {
  type?: InputMaybe<Scalars["String"]["input"]>;
};

/** User onboarding information */
export type UserOnboarding = {
  completed_at?: Maybe<Scalars["Date"]["output"]>;
  skipped_at?: Maybe<Scalars["Date"]["output"]>;
  steps?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  type?: Maybe<Scalars["String"]["output"]>;
};

/** Bulk person validation response */
export type ValidatePeopleResponse = {
  people?: Maybe<Array<Maybe<Person>>>;
};

/** Person validation response */
export type ValidatePersonResponse = {
  person?: Maybe<Person>;
};

/** The viewer who has logged in. */
export type Viewer = {
  avatar_url?: Maybe<Scalars["String"]["output"]>;
  birthday?: Maybe<Scalars["String"]["output"]>;
  default_account_id?: Maybe<Scalars["Int"]["output"]>;
  default_organization_id?: Maybe<Scalars["Int"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  first_name?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated This field is deprecated and will be removed in a future version. This just returns null */
  has_password_login?: Maybe<Scalars["Boolean"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  initials?: Maybe<Scalars["String"]["output"]>;
  last_name?: Maybe<Scalars["String"]["output"]>;
  linkedIn?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  occupation?: Maybe<Scalars["String"]["output"]>;
  onboarding?: Maybe<UserOnboarding>;
  phone?: Maybe<Scalars["String"]["output"]>;
  showGettingStarted?: Maybe<Scalars["Boolean"]["output"]>;
  showPositionTour?: Maybe<Scalars["Boolean"]["output"]>;
  showTeamTour?: Maybe<Scalars["Boolean"]["output"]>;
  survey_completion?: Maybe<Array<Maybe<SurveyCompletion>>>;
  /** @deprecated This field is deprecated and will be removed in a future version. Use survey_completion instead. This just returns null */
  surveys?: Maybe<Array<Maybe<ActiveSurvey>>>;
  type?: Maybe<Scalars["String"]["output"]>;
};

export type WorkspaceAccessLevel = "EDIT" | "FULL" | "LIMITED" | "NONE";

export type WorkspaceRoles =
  | "ADMIN"
  | "CANDIDATE"
  | "CONTACT"
  | "MEMBER"
  | "OWNER";

export type AcceptInviteMutationVariables = Exact<{
  acceptInviteId: Scalars["Int"]["input"];
}>;

export type AcceptInviteMutation = {
  __typename: "RootMutation";
  acceptInvite?:
    | {
        __typename: "AcceptInviteMutationResponse";
        redirect?:
          | {
              __typename: "RedirectType";
              url?: string | null | undefined;
              account_id?: number | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type UpdatePasswordMutationVariables = Exact<{
  old_password: Scalars["String"]["input"];
  new_password: Scalars["String"]["input"];
  repeat_new_password: Scalars["String"]["input"];
}>;

export type UpdatePasswordMutation = {
  __typename: "RootMutation";
  updatePassword?:
    | { __typename: "Viewer"; id?: number | null | undefined }
    | null
    | undefined;
};

export type AuthorizedPersonQueryVariables = Exact<{ [key: string]: never }>;

export type AuthorizedPersonQuery = {
  __typename: "RootQuery";
  authorizedPerson?:
    | {
        __typename: "Person";
        id?: number | null | undefined;
        first_name?: string | null | undefined;
        last_name?: string | null | undefined;
        name?: string | null | undefined;
        email?: string | null | undefined;
        avatar?: string | null | undefined;
        initials?: string | null | undefined;
        linkedin?: string | null | undefined;
        phone?: string | null | undefined;
        completed_dim_types?:
          | Array<string | null | undefined>
          | null
          | undefined;
        invite?:
          | {
              __typename: "PersonInvite";
              created_at?: string | null | undefined;
              secret?: string | null | undefined;
            }
          | null
          | undefined;
        roles?:
          | Array<
              | {
                  __typename: "PersonRole";
                  id?: string | null | undefined;
                  obj_id?: number | null | undefined;
                  role?: string | null | undefined;
                  type?: string | null | undefined;
                  access_level?: string | null | undefined;
                  person_id?: number | null | undefined;
                  actions?: Array<string | null | undefined> | null | undefined;
                  administration?:
                    | {
                        __typename: "PermissionAdministration";
                        id?: string | null | undefined;
                        can_change_access_level?: boolean | null | undefined;
                        can_change_role?: boolean | null | undefined;
                        can_invite?: boolean | null | undefined;
                        can_revoke?: boolean | null | undefined;
                        max_grant_role?: string | null | undefined;
                        max_grant_access_level?: string | null | undefined;
                        grantable_roles?:
                          | Array<string | null | undefined>
                          | null
                          | undefined;
                        grantable_access_levels?:
                          | Array<string | null | undefined>
                          | null
                          | undefined;
                        constraints?:
                          | {
                              __typename: "PermissionAdministrationConstraints";
                              organization_full_implies_admin?:
                                | boolean
                                | null
                                | undefined;
                              workspace_admin_edit_no_manage_people?:
                                | boolean
                                | null
                                | undefined;
                              notes?:
                                | Array<string | null | undefined>
                                | null
                                | undefined;
                            }
                          | null
                          | undefined;
                      }
                    | null
                    | undefined;
                }
              | null
              | undefined
            >
          | null
          | undefined;
        survey_completion?:
          | Array<
              | {
                  __typename: "SurveyCompletion";
                  survey_id?: number | null | undefined;
                  survey_type?: string | null | undefined;
                  text_id?: string | null | undefined;
                  completed?: boolean | null | undefined;
                }
              | null
              | undefined
            >
          | null
          | undefined;
        assessment_orders?:
          | Array<
              | {
                  __typename: "AssessmentOrder";
                  id?: number | null | undefined;
                  assessment_type?: string | null | undefined;
                  assessment_link?: string | null | undefined;
                  status?: string | null | undefined;
                  completed_at?: string | null | undefined;
                  created_at?: string | null | undefined;
                }
              | null
              | undefined
            >
          | null
          | undefined;
        summary?:
          | {
              __typename: "Summary";
              text?: string | null | undefined;
              updated_at?: string | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type ViewerQueryVariables = Exact<{ [key: string]: never }>;

export type ViewerQuery = {
  __typename: "RootQuery";
  viewer?:
    | {
        __typename: "Viewer";
        id?: number | null | undefined;
        type?: string | null | undefined;
        default_organization_id?: number | null | undefined;
        default_account_id?: number | null | undefined;
        name?: string | null | undefined;
        email?: string | null | undefined;
        occupation?: string | null | undefined;
        linkedIn?: string | null | undefined;
        phone?: string | null | undefined;
        avatar_url?: string | null | undefined;
        initials?: string | null | undefined;
        first_name?: string | null | undefined;
        last_name?: string | null | undefined;
        has_password_login?: boolean | null | undefined;
        showGettingStarted?: boolean | null | undefined;
        showPositionTour?: boolean | null | undefined;
        showTeamTour?: boolean | null | undefined;
        survey_completion?:
          | Array<
              | {
                  __typename: "SurveyCompletion";
                  survey_id?: number | null | undefined;
                  survey_type?: string | null | undefined;
                  text_id?: string | null | undefined;
                  completed?: boolean | null | undefined;
                }
              | null
              | undefined
            >
          | null
          | undefined;
        onboarding?:
          | {
              __typename: "UserOnboarding";
              type?: string | null | undefined;
              completed_at?: string | null | undefined;
              skipped_at?: string | null | undefined;
              steps?: Array<string | null | undefined> | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type RoleFieldsFragment = {
  __typename: "PersonRole";
  id?: string | null | undefined;
  obj_id?: number | null | undefined;
  role?: string | null | undefined;
  type?: string | null | undefined;
  access_level?: string | null | undefined;
  person_id?: number | null | undefined;
  actions?: Array<string | null | undefined> | null | undefined;
  administration?:
    | {
        __typename: "PermissionAdministration";
        id?: string | null | undefined;
        can_change_access_level?: boolean | null | undefined;
        can_change_role?: boolean | null | undefined;
        can_invite?: boolean | null | undefined;
        can_revoke?: boolean | null | undefined;
        max_grant_role?: string | null | undefined;
        max_grant_access_level?: string | null | undefined;
        grantable_roles?: Array<string | null | undefined> | null | undefined;
        grantable_access_levels?:
          | Array<string | null | undefined>
          | null
          | undefined;
        constraints?:
          | {
              __typename: "PermissionAdministrationConstraints";
              organization_full_implies_admin?: boolean | null | undefined;
              workspace_admin_edit_no_manage_people?:
                | boolean
                | null
                | undefined;
              notes?: Array<string | null | undefined> | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type RoleLiteFieldsFragment = {
  __typename: "PersonRole";
  id?: string | null | undefined;
  obj_id?: number | null | undefined;
  role?: string | null | undefined;
  type?: string | null | undefined;
  access_level?: string | null | undefined;
  person_id?: number | null | undefined;
};

export const RoleFieldsFragmentDoc = gql`
  fragment RoleFields on PersonRole {
    id
    obj_id
    role
    type
    access_level
    person_id
    actions
    administration {
      id
      can_change_access_level
      can_change_role
      can_invite
      can_revoke
      max_grant_role
      max_grant_access_level
      grantable_roles
      grantable_access_levels
      constraints {
        organization_full_implies_admin
        workspace_admin_edit_no_manage_people
        notes
      }
    }
  }
`;
export const RoleLiteFieldsFragmentDoc = gql`
  fragment RoleLiteFields on PersonRole {
    id
    obj_id
    role
    type
    access_level
    person_id
  }
`;
export const AcceptInviteDocument = gql`
  mutation AcceptInvite($acceptInviteId: Int!) {
    acceptInvite(id: $acceptInviteId) {
      redirect {
        url
        account_id
      }
    }
  }
`;
export type AcceptInviteMutationFn = Apollo.MutationFunction<
  AcceptInviteMutation,
  AcceptInviteMutationVariables
>;

/**
 * __useAcceptInviteMutation__
 *
 * To run a mutation, you first call `useAcceptInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInviteMutation, { data, loading, error }] = useAcceptInviteMutation({
 *   variables: {
 *      acceptInviteId: // value for 'acceptInviteId'
 *   },
 * });
 */
export function useAcceptInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcceptInviteMutation,
    AcceptInviteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AcceptInviteMutation,
    AcceptInviteMutationVariables
  >(AcceptInviteDocument, options);
}
export type AcceptInviteMutationHookResult = ReturnType<
  typeof useAcceptInviteMutation
>;
export type AcceptInviteMutationResult =
  Apollo.MutationResult<AcceptInviteMutation>;
export type AcceptInviteMutationOptions = Apollo.BaseMutationOptions<
  AcceptInviteMutation,
  AcceptInviteMutationVariables
>;
export const UpdatePasswordDocument = gql`
  mutation UpdatePassword(
    $old_password: String!
    $new_password: String!
    $repeat_new_password: String!
  ) {
    updatePassword(
      old_password: $old_password
      new_password: $new_password
      repeat_new_password: $repeat_new_password
    ) {
      id
    }
  }
`;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<
  UpdatePasswordMutation,
  UpdatePasswordMutationVariables
>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      old_password: // value for 'old_password'
 *      new_password: // value for 'new_password'
 *      repeat_new_password: // value for 'repeat_new_password'
 *   },
 * });
 */
export function useUpdatePasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePasswordMutation,
    UpdatePasswordMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePasswordMutation,
    UpdatePasswordMutationVariables
  >(UpdatePasswordDocument, options);
}
export type UpdatePasswordMutationHookResult = ReturnType<
  typeof useUpdatePasswordMutation
>;
export type UpdatePasswordMutationResult =
  Apollo.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<
  UpdatePasswordMutation,
  UpdatePasswordMutationVariables
>;
export const AuthorizedPersonDocument = gql`
  query AuthorizedPerson {
    authorizedPerson {
      id
      first_name
      last_name
      name
      email
      avatar
      initials
      linkedin
      phone
      invite {
        created_at
        secret
      }
      roles {
        ...RoleFields
      }
      survey_completion {
        survey_id
        survey_type
        text_id
        completed
      }
      assessment_orders {
        id
        assessment_type
        assessment_link
        status
        completed_at
        created_at
      }
      completed_dim_types
      summary {
        text
        updated_at
      }
    }
  }
  ${RoleFieldsFragmentDoc}
`;

/**
 * __useAuthorizedPersonQuery__
 *
 * To run a query within a React component, call `useAuthorizedPersonQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorizedPersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorizedPersonQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthorizedPersonQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AuthorizedPersonQuery,
    AuthorizedPersonQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AuthorizedPersonQuery, AuthorizedPersonQueryVariables>(
    AuthorizedPersonDocument,
    options
  );
}
export function useAuthorizedPersonLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AuthorizedPersonQuery,
    AuthorizedPersonQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AuthorizedPersonQuery,
    AuthorizedPersonQueryVariables
  >(AuthorizedPersonDocument, options);
}
export function useAuthorizedPersonSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AuthorizedPersonQuery,
        AuthorizedPersonQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AuthorizedPersonQuery,
    AuthorizedPersonQueryVariables
  >(AuthorizedPersonDocument, options);
}
export type AuthorizedPersonQueryHookResult = ReturnType<
  typeof useAuthorizedPersonQuery
>;
export type AuthorizedPersonLazyQueryHookResult = ReturnType<
  typeof useAuthorizedPersonLazyQuery
>;
export type AuthorizedPersonSuspenseQueryHookResult = ReturnType<
  typeof useAuthorizedPersonSuspenseQuery
>;
export type AuthorizedPersonQueryResult = Apollo.QueryResult<
  AuthorizedPersonQuery,
  AuthorizedPersonQueryVariables
>;
export const ViewerDocument = gql`
  query Viewer {
    viewer {
      id
      type
      default_organization_id
      default_account_id
      name
      email
      occupation
      linkedIn
      phone
      avatar_url
      initials
      first_name
      last_name
      has_password_login
      survey_completion {
        survey_id
        survey_type
        text_id
        completed
      }
      showGettingStarted
      showPositionTour
      showTeamTour
      onboarding {
        type
        completed_at
        skipped_at
        steps
      }
    }
  }
`;

/**
 * __useViewerQuery__
 *
 * To run a query within a React component, call `useViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerQuery(
  baseOptions?: Apollo.QueryHookOptions<ViewerQuery, ViewerQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ViewerQuery, ViewerQueryVariables>(
    ViewerDocument,
    options
  );
}
export function useViewerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ViewerQuery, ViewerQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ViewerQuery, ViewerQueryVariables>(
    ViewerDocument,
    options
  );
}
export function useViewerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ViewerQuery, ViewerQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ViewerQuery, ViewerQueryVariables>(
    ViewerDocument,
    options
  );
}
export type ViewerQueryHookResult = ReturnType<typeof useViewerQuery>;
export type ViewerLazyQueryHookResult = ReturnType<typeof useViewerLazyQuery>;
export type ViewerSuspenseQueryHookResult = ReturnType<
  typeof useViewerSuspenseQuery
>;
export type ViewerQueryResult = Apollo.QueryResult<
  ViewerQuery,
  ViewerQueryVariables
>;
